import { useEffect, useState } from 'react';
import { s } from '../components/list/List.styles';
import Select, { SingleValue } from 'react-select';
import { ReportFormatNumber } from '../../func/Function';

import {
  ListDataProps,
  SortOption,
  SortOptions,
  BondListItemProps,
} from '../components/list/data';
import Pagination from '../components/pagination/Pagination';
import { useNavigate } from 'react-router-dom';

interface ListCardProps {
  data: BondListItemProps[];

  totalCount: number;
  sort: SortOption;
  setSort: (sort: SortOption) => void;
  offset?: number;
  setOffset: (offset: number) => void;
  filters?: any;
  bondFilters?: any;
  limit: number;
  loading: boolean;
  page: string;
  setSelectedIdx: (idx: number) => void;
  setShowLikeModal?: (value: boolean) => void;
  setMode?: (value: string) => void;
  setSelectedItem: (value: {
    iidx: number;
    group: string;
    group_idx: number;
    level: number;
    memo: string;
  }) => void;
  activeItem: number | null;
  setActiveItem: (value: number | null) => void;
  getList: (
    offset: number,
    sort: {
      value: string;
      label: string;
    },
    filters?: any,
  ) => void;
}
const BondList = ({
  data,
  totalCount,
  sort,
  setSort,
  offset,
  setOffset,
  filters,
  bondFilters,
  limit,
  loading,
  page,
}: ListCardProps) => {
  filters = filters || bondFilters;
  const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set());
  const [expandedMemos, setExpandedMemos] = useState<Set<number>>(new Set());
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);

  const navigate = useNavigate();

  const toggleMemoExpand = (index: number) => {
    setExpandedMemos((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  useEffect(() => {
    if (totalCount) {
      setTotalPages(Math.ceil(totalCount / limit));
    }
  }, [totalCount]);

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '8px',
      border: 'none',
      height: '40px',
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      padding: 0,
      backgroundColor: '#F7F8FC',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      order: 1,
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      backgroundColor: state.isSelected ? '#e6e6e6' : provided.backgroundColor,
      color: state.isSelected ? '#000' : '#333',
    }),
    placeholder: (provided: any) => ({
      ...provided,
      whiteSpace: 'nowrap',
    }),
  };
  const toggleExpand = (index: number) => {
    setExpandedRows((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  const renderTags = (tags: string[], index: number) => {
    const isExpanded = expandedRows.has(index);
    const maxVisibleTags = 2;

    if (!tags || tags.length === 0) return null;

    if (isExpanded) {
      return (
        <>
          {tags.map((tag, i) => (
            <s.TagText key={`${index}-${i}`}>{tag}</s.TagText>
          ))}

          <s.TagText
            onClick={(e) => {
              e.stopPropagation();
              toggleExpand(index);
            }}
          >
            <span>접기</span>
            <img
              src="/assets/images/arrow/arrow-down-gray.svg"
              alt=""
              style={{ width: '16px', transform: 'rotate(180deg)' }}
            />
          </s.TagText>
        </>
      );
    } else {
      const visibleTags = tags.slice(0, maxVisibleTags);
      const remainingCount = tags.length - maxVisibleTags;

      return (
        <>
          {visibleTags.map((tag, i) => (
            <s.TagText key={`${index}-${i}`}>{tag}</s.TagText>
          ))}
          {remainingCount > 0 && (
            <s.TagText
              onClick={(e) => {
                e.stopPropagation();
                toggleExpand(index);
              }}
            >
              +{remainingCount}개
            </s.TagText>
          )}
        </>
      );
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setOffset((page - 1) * limit);
  };

  const NoDataText = () => {
    if (page === 'search') {
      return '검색 결과가 없습니다';
    }
    if (page === 'interest') {
      return '관심물건이 없습니다.';
    }
    if (page === 'recent') {
      return '최근 열람 물건이 없습니다.';
    }
  };

  return (
    <s.Container id="list-top">
      <s.ListTop>
        <div>총 {Number(totalCount).toLocaleString()}개</div>
        <Select<SortOption>
          options={SortOptions}
          styles={{
            ...customStyles,
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          placeholder="선택"
          value={sort}
          onChange={(selectedOption: SingleValue<SortOption>) => {
            if (selectedOption) {
              setSort(selectedOption);
            }
          }}
        />
      </s.ListTop>
      {!loading && data.length > 0 && (
        <s.ListBox>
          <s.List>
            {data.map((item, index) => (
              <s.ListCard
                isActive={false}
                key={index}
                onClick={() => {
                  // if (item.type === 'a') {
                  //   navigate(`/auction/detail/${item.iidx2}`);
                  // } else {
                  //   navigate(`/pauction/detail/${item.iidx2}`);
                  // }
                  //페이지가 생기면 해당 페이지로 이동 연결
                }}
              >
                <s.ItemInfoBox>
                  <s.ItemTypeChip
                    style={{ width: '100%', justifyContent: 'flex-start' }}
                  >
                    {item.blue_tag}
                  </s.ItemTypeChip>
                </s.ItemInfoBox>
                <s.ListCardContentBox>
                  <s.CardTextBox>
                    <s.CardTitle>{item.title}</s.CardTitle>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 4,
                      }}
                    >
                      <s.CardPrice>
                        감정가 {ReportFormatNumber(item.a_price)}
                      </s.CardPrice>
                      <s.CardPrice style={{ color: '#09AB49' }}>
                        희망가 {ReportFormatNumber(item.h_price)}
                      </s.CardPrice>
                    </div>
                  </s.CardTextBox>
                  <s.CardImgBox>
                    <div style={{ position: 'relative' }}>
                      <img
                        src={
                          item.img === null
                            ? '/assets/images/no-image.svg'
                            : item.img
                        }
                        alt=""
                        style={{
                          height: 80,
                          width: 80,
                          borderRadius: 8,
                        }}
                      />
                    </div>

                    <s.ViewCount>
                      <img src="/assets/images/icon/view-gray.svg" alt="" />
                      <span>{item.count ?? 0}회</span>
                    </s.ViewCount>
                  </s.CardImgBox>
                </s.ListCardContentBox>
                <s.HashTagWrapper>
                  {renderTags(
                    [
                      ...(item.viewgray2
                        ? item.viewgray2.split(' / ').filter((el) => el !== '')
                        : []),
                    ],
                    index,
                  )}
                </s.HashTagWrapper>
              </s.ListCard>
            ))}
          </s.List>
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </s.ListBox>
      )}
      {data.length === 0 && <s.Nodata>{NoDataText()}</s.Nodata>}
    </s.Container>
  );
};

export default BondList;
